let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b8unI")).then(() => parcelRequire('1H8nC'));